module.exports = __webpack_public_path__ + "454b8b79d44a5926906d135bf0c80d26.svg";